<template>
  <v-container class="grey lighten-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Edytuj plan
          </v-card-title>
          <v-card-text>
            <PlanAddEdit
                :id="this.id"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PlanAddEdit from "@/components/subscriptions/PlanAddEdit";

export default {
  components: {
    PlanAddEdit,
  },
  props: {
    id: {
      type: [String],
      required: true,
    }
  },
}
</script>